export default {
    id: 'red-orange-green',
    colors: ['#FF3D64', '#FFC636', '#54A520'],
};
